export default {
  data() {
    return {
      count: "",
      //倒计时
      logoImg: require('@/assets/img/changliang.png')
    };
  },
  created() {
    const timejump = 10;
    if (!this.timer) {
      this.count = timejump;
      this.show = false;
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= timejump) {
          this.count--;
          if (this.count == 0) {
            this.count = '';
          }
        } else {
          this.show = true;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  },
  mounted() {},
  methods: {
    //几秒后进入跳转页面
    clickJump() {
      window.location.href = 'https://lccf.erichfund.com/collection/small/loginpage';
    }
  }
};